/** CRM workflow: Lead → inventory mapping → Buyer → Deal — single source of truth */

export const VISIT_STATUSES = [
  { id: 'NotVisited', label: 'Not visited', color: '#8898aa' },
  { id: 'Scheduled', label: 'Visit scheduled', color: '#5e72e4' },
  { id: 'Visited', label: 'Visited', color: '#11cdef' },
  { id: 'Interested', label: 'Interested', color: '#2dce89' },
  { id: 'Rejected', label: 'Rejected', color: '#f5365c' },
  { id: 'OnHold', label: 'On hold', color: '#fb6340' },
];

export const DEAL_STAGES = [
  { id: 'NewInquiry', label: 'New inquiry', color: '#8898aa' },
  { id: 'Qualified', label: 'Qualified', color: '#5e72e4' },
  { id: 'SiteVisit', label: 'Site visit', color: '#11cdef' },
  { id: 'Interested', label: 'Interested', color: '#2dce89' },
  { id: 'Negotiation', label: 'Negotiation', color: '#fb6340' },
  { id: 'Booking', label: 'Booking', color: '#825ee4' },
  { id: 'Agreement', label: 'Agreement', color: '#344767' },
  { id: 'ClosedWon', label: 'Closed won', color: '#2dce89' },
  { id: 'ClosedLost', label: 'Closed lost', color: '#f5365c' },
];

export const getVisitStatus = (id) =>
  VISIT_STATUSES.find((v) => v.id === id) ?? { id, label: id ?? '—', color: '#8898aa' };

export const getDealStage = (id) =>
  DEAL_STAGES.find((s) => s.id === id) ?? { id, label: id ?? '—', color: '#8898aa' };
